import { Breadcrumbs, Skeleton, styled, Typography } from '@mui/material';
import { ITheme } from 'theme/types';


export const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
  fontSize: '0.75rem', // SMALL_FONT_SIZE equivalent

  '& .MuiBreadcrumbs-separator': {
    color: (theme as unknown as ITheme).palette.grey['300'],
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));

export const BreadcrumbLink = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem', // SMALL_FONT_SIZE equivalent
  color: theme.palette.text.secondary,
}));

export const BreadcrumbText = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem', // SMALL_FONT_SIZE equivalent
  color: (theme as unknown as ITheme).palette.grey['400'],
}));

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
  fontSize: '0.75rem', // SMALL_FONT_SIZE equivalent
}));